var nunjucks = require("nunjucks/browser/nunjucks-slim");
var env;
if (!nunjucks.currentEnv){
	env = nunjucks.currentEnv = new nunjucks.Environment([], undefined);
} else {
	env = nunjucks.currentEnv;
}
var configure = require("../../core/js/filters/nunjucks-config.js")(env);
var dependencies = nunjucks.webpackDependencies || (nunjucks.webpackDependencies = {});
dependencies["macros/product-author-macros.j2"] = require( "macros/product-author-macros.j2" );
dependencies["product-reviews-user-info.j2"] = require( "product-reviews-user-info.j2" );
dependencies["user-review-photos.j2"] = require( "user-review-photos.j2" );
dependencies["user-review-title-section.j2"] = require( "user-review-title-section.j2" );
dependencies["macros/text-truncate-macro.j2"] = require( "macros/text-truncate-macro.j2" );
dependencies["product-reviews-fit-rating.j2"] = require( "product-reviews-fit-rating.j2" );
dependencies["product-reviews-response.j2"] = require( "product-reviews-response.j2" );




var shim = require("/jh/workspace/MonoWeb-Build-Release/monoweb/node_modules/nunjucks-loader/runtime-shim");


(function() {(nunjucks.nunjucksPrecompiled = nunjucks.nunjucksPrecompiled || {})["product/templates/product-reviews.j2"] = (function() {
function root(env, context, frame, runtime, cb) {
var lineno = null;
var colno = null;
var output = "";
try {
var parentTemplate = null;
env.getTemplate("macros/product-author-macros.j2", false, "product/templates/product-reviews.j2", false, function(t_2,t_1) {
if(t_2) { cb(t_2); return; }
t_1.getExported(context.getVariables(), frame, function(t_3,t_1) {
if(t_3) { cb(t_3); return; }
context.setVariable("authors", t_1);
output += "\n\n";
output += "\n\n<div class=\"c-product-reviews\" data-qa-reviews>";
frame = frame.push();
var t_6 = runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "product")),"productReviews")),"Results");
if(t_6) {var t_5 = t_6.length;
for(var t_4=0; t_4 < t_6.length; t_4++) {
var t_7 = t_6[t_4];
frame.set("review", t_7);
frame.set("loop.index", t_4 + 1);
frame.set("loop.index0", t_4);
frame.set("loop.revindex", t_5 - t_4);
frame.set("loop.revindex0", t_5 - t_4 - 1);
frame.set("loop.first", t_4 === 0);
frame.set("loop.last", t_4 === t_5 - 1);
frame.set("loop.length", t_5);
output += "<div class=\"c-product-reviews__inner\" data-qa-review>\n\n            <div class=\"o-row\">\n\n                <div class=\"o-column o-extra-small--12 o-medium--4\">\n\n                    <div class=\"u-extra-small--hide u-medium--show\">\n                        ";
env.getTemplate("product-reviews-user-info.j2", false, "product/templates/product-reviews.j2", null, function(t_10,t_8) {
if(t_10) { cb(t_10); return; }
t_8.render(context.getVariables(), frame, function(t_11,t_9) {
if(t_11) { cb(t_11); return; }
output += t_9
output += "\n                    </div>\n\n                    ";
var t_12;
t_12 = runtime.memberLookup((runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "core")),"featureConfigs")),"browseDisplayOptions")),"showReadReviewPhoto");
frame.set("showReadReviewPhoto", t_12, true);
if(frame.topLevel) {
context.setVariable("showReadReviewPhoto", t_12);
}
if(frame.topLevel) {
context.addExport("showReadReviewPhoto", t_12);
}
if(runtime.contextOrFrameLookup(context, frame, "showReadReviewPhoto")) {
output += "<div class=\"u-extra-small--hide u-medium--show\">\n                            ";
env.getTemplate("user-review-photos.j2", false, "product/templates/product-reviews.j2", null, function(t_15,t_13) {
if(t_15) { cb(t_15); return; }
t_13.render(context.getVariables(), frame, function(t_16,t_14) {
if(t_16) { cb(t_16); return; }
output += t_14
output += "\n                        </div>";
})});
}
output += "</div>\n\n                <div class=\"o-column o-extra-small--12 o-medium--8\">\n\n                    <div class=\"c-product-review\">\n\n                        <div class=\"c-product-review__title-section\" data-qa-review-title>\n\n                            ";
env.getTemplate("user-review-title-section.j2", false, "product/templates/product-reviews.j2", null, function(t_19,t_17) {
if(t_19) { cb(t_19); return; }
t_17.render(context.getVariables(), frame, function(t_20,t_18) {
if(t_20) { cb(t_20); return; }
output += t_18
output += "\n\n                        </div>";
if(runtime.memberLookup((t_7),"ReviewText")) {
output += "<div class=\"c-product-review__review-text\" data-qa-review-body>\n                            ";
output += "\n                            ";
var t_21;
t_21 = runtime.memberLookup((runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "core")),"featureConfigs")),"browseDisplayOptions")),"reviewTextLimit");
frame.set("textLimit", t_21, true);
if(frame.topLevel) {
context.setVariable("textLimit", t_21);
}
if(frame.topLevel) {
context.addExport("textLimit", t_21);
}
output += "\n                            ";
output += "\n                            ";
env.getTemplate("macros/text-truncate-macro.j2", false, "product/templates/product-reviews.j2", false, function(t_23,t_22) {
if(t_23) { cb(t_23); return; }
t_22.getExported(context.getVariables(), frame, function(t_24,t_22) {
if(t_24) { cb(t_24); return; }
frame.set("textTruncate", t_22);
output += "\n                            ";
output += runtime.suppressValue((lineno = 44, colno = 54, runtime.callWrap(runtime.memberLookup((t_22),"truncateText"), "textTruncate[\"truncateText\"]", context, [runtime.memberLookup((t_7),"ReviewText"),runtime.contextOrFrameLookup(context, frame, "textLimit"),runtime.contextOrFrameLookup(context, frame, "None"),"review"])), env.opts.autoescape);
output += "\n\n                        </div>";
})});
}
env.getTemplate("product-reviews-fit-rating.j2", false, "product/templates/product-reviews.j2", null, function(t_27,t_25) {
if(t_27) { cb(t_27); return; }
t_25.render(context.getVariables(), frame, function(t_28,t_26) {
if(t_28) { cb(t_28); return; }
output += t_26
var t_29;
t_29 = (lineno = 51, colno = 57, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "_get_from_obj"), "_get_from_obj", context, [t_7,"ContextDataValues.FitPurchased.Value"]));
frame.set("fitPurchased", t_29, true);
if(frame.topLevel) {
context.setVariable("fitPurchased", t_29);
}
if(frame.topLevel) {
context.addExport("fitPurchased", t_29);
}
if(runtime.contextOrFrameLookup(context, frame, "fitPurchased")) {
output += "<p class=\"c-product-review__body-text\">\n                                <span class=\"c-product-review__body-text--strong\">";
output += runtime.suppressValue((lineno = 55, colno = 84, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "t"), "t", context, ["product_reviews-fit-purchased-label"])), env.opts.autoescape);
output += ": </span> ";
output += runtime.suppressValue(runtime.contextOrFrameLookup(context, frame, "fitPurchased"), env.opts.autoescape);
output += "\n                            </p>";
;
}
var t_30;
t_30 = (lineno = 59, colno = 58, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "_get_from_obj"), "_get_from_obj", context, [t_7,"AdditionalFields.SizePurchased.Value"]));
frame.set("sizePurchased", t_30, true);
if(frame.topLevel) {
context.setVariable("sizePurchased", t_30);
}
if(frame.topLevel) {
context.addExport("sizePurchased", t_30);
}
if(runtime.contextOrFrameLookup(context, frame, "sizePurchased")) {
output += "<p class=\"c-product-review__body-text\">\n                                <span class=\"c-product-review__body-text--strong\">";
output += runtime.suppressValue((lineno = 63, colno = 84, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "t"), "t", context, ["product_reviews-size-purchased-label"])), env.opts.autoescape);
output += ": </span> ";
output += runtime.suppressValue(runtime.contextOrFrameLookup(context, frame, "sizePurchased"), env.opts.autoescape);
output += "\n                            </p>";
;
}
var t_31;
t_31 = (lineno = 67, colno = 61, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "_get_from_obj"), "_get_from_obj", context, [t_7,"AdditionalFields.SizeNormallyWorn.Value"]));
frame.set("sizeNormallyWorn", t_31, true);
if(frame.topLevel) {
context.setVariable("sizeNormallyWorn", t_31);
}
if(frame.topLevel) {
context.addExport("sizeNormallyWorn", t_31);
}
if(runtime.contextOrFrameLookup(context, frame, "sizeNormallyWorn")) {
output += "<p class=\"c-product-review__body-text\">\n                                <span class=\"c-product-review__body-text--strong\">";
output += runtime.suppressValue((lineno = 71, colno = 84, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "t"), "t", context, ["product_reviews-size-worn-label"])), env.opts.autoescape);
output += ": </span> ";
output += runtime.suppressValue(runtime.contextOrFrameLookup(context, frame, "sizeNormallyWorn"), env.opts.autoescape);
output += "\n                            </p>";
;
}
output += "<p class=\"c-product-review__body-text--recommendation\">\n\n                            ";
if(runtime.memberLookup((t_7),"IsRecommended")) {
output += "\n\n                                <span class=\"c-product-review__body-text--strong\">";
output += runtime.suppressValue((lineno = 79, colno = 84, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "t"), "t", context, ["product_reviews-recommendation-yes"])), env.opts.autoescape);
output += "</span> ";
output += runtime.suppressValue((lineno = 79, colno = 133, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "t"), "t", context, ["product_reviews-recommendation-true"])), env.opts.autoescape);
output += "\n\n                            ";
;
}
else {
if(runtime.memberLookup((t_7),"IsRecommended") != null) {
output += "\n\n                                <span class=\"c-product-review__body-text--strong\">";
output += runtime.suppressValue((lineno = 83, colno = 84, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "t"), "t", context, ["product_reviews-recommendation-no"])), env.opts.autoescape);
output += "</span> ";
output += runtime.suppressValue((lineno = 83, colno = 132, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "t"), "t", context, ["product_reviews-recommendation-false"])), env.opts.autoescape);
output += "\n\n                            ";
;
}
;
}
output += "\n\n                        </p>\n\n                        ";
if((lineno = 89, colno = 32, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "_get"), "_get", context, ["core.constants.pdpOptions.show_client_response_for_reviews"]))) {
output += "\n\n                            ";
env.getTemplate("product-reviews-response.j2", false, "product/templates/product-reviews.j2", null, function(t_34,t_32) {
if(t_34) { cb(t_34); return; }
t_32.render(context.getVariables(), frame, function(t_35,t_33) {
if(t_35) { cb(t_35); return; }
output += t_33
})});
}
output += "<div class=\"u-extra-small--show u-medium--hide\">\n                            ";
env.getTemplate("product-reviews-user-info.j2", false, "product/templates/product-reviews.j2", null, function(t_38,t_36) {
if(t_38) { cb(t_38); return; }
t_36.render(context.getVariables(), frame, function(t_39,t_37) {
if(t_39) { cb(t_39); return; }
output += t_37
output += "\n                        </div>\n\n                        ";
output += "\n                        ";
output += "\n\n                        ";
output += "\n\n                    </div>\n\n                </div>\n\n            </div>\n\n            ";
if(!runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "loop")),"last")) {
output += "\n\n                <div class=\"o-row\">\n\n                    <div class=\"o-column o-extra-small--12\">\n\n                        <hr class=\"c-product-reviews__hr\" />\n\n                    </div>\n\n                </div>\n\n            ";
;
}
output += "\n\n        </div>\n        ";
})})})})})})})});
}
}
frame = frame.pop();
output += "</div>\n";
if(parentTemplate) {
parentTemplate.rootRenderFunc(env, context, frame, runtime, cb);
} else {
cb(null, output);
}
})});
} catch (e) {
  cb(runtime.handleError(e, lineno, colno));
}
}
return {
root: root
};

})();
})();



module.exports = shim(nunjucks, env, nunjucks.nunjucksPrecompiled["product/templates/product-reviews.j2"] , dependencies)